import { CustomerRecord } from "./CustomerRecord";
import { DeleteRecord } from "./DeleteRecord";
import { EmployeeRecord } from "./EmployeeRecord";
import { GuestVenueVisit } from "./GuestVenueVisit";
import { MBCheck } from "./MBCheck";
import { OrderType } from "./OrderType";
import { RevenueCenter } from "./RevenueCenter";
import { SeatRecord } from "./SeatRecord";
import { Station } from "./Station";
import { Store } from "./Store";
import { TimeCard } from "./TimeCard";

export class CheckRecord {
	venueKey: number;
	CheckDate: string;
	ID: number;
	businessDate: string;

	NumberOfSeats: number;

	FlagOpen: boolean;
	FlagUnused: boolean;
	FlagTabName: boolean;
	FlagReopened: boolean;
	FlagTransferred: boolean;
	FlagBeverages: boolean;
	FlagAppetizers: boolean;
	FlagEntrees: boolean;
	FlagDesserts: boolean;
	FlagRenumbered: boolean;

	TimeOpened: string;
	OpenerID: number;
	OpenerName: string;
	OwnerID: number;
	OwnerName: string;
	OwnerTimeCardID: string;
	TimeClosed: string;
	CloserID: number;
	CloserName: string;
	CloserTimeCardID: string;
	StationClosedID: number;
	Table: string;
	Guests: number;
	OrderTypeID: number;
	RevenueCenterID: number;
	StationOpenedID: number;
	Total: number;
	DiscountTotalAmount: number;
	VoidTotalAmount: number;

	TaxableSales1: number;
	TaxableSales2: number;
	TaxableSales3: number;
	TaxableSales4: number;
	TaxableSales5: number;
	TaxableSales6: number;
	TaxableSales7: number;
	TaxableSales8: number;
	TaxableSales9: number;
	TaxableSales10: number;
	TaxableSales11: number;
	TaxableSales12: number;
	TaxableSales13: number;
	TaxableSales14: number;
	TaxableSales15: number;
	TaxableSales16: number;
	GiftCardItemDiscount: number;

	CustomerID: string;

	modified: Date;

	checkKey: string;
	source: string;

	FlagsReopened: string;
	FlagsTabNameEntered: string;
	FlagsTransferred: string;
	FlagsBeveragesOrdered;
	FlagsAppetizersOrdered: string;
	FlagsEntreesOrdered: string;
	FlagsDessertsOrdered: string;
	FlagsOpen: string;
	FlagsRenumbered: string;
	FlagsUsed: string; //this is here for reference purpose only. Conditional looks to see if value = 'N' and doesn't iterate the check if true

	SeatRecord: SeatRecord[];

	stores: Store;

	CustomerRecord: CustomerRecord;

	CheckOwner: EmployeeRecord;

	CheckOpener: EmployeeRecord;

	CheckCloser: EmployeeRecord;

	OwnerTimeCard: TimeCard;

	CloserTimeCard: TimeCard;

	OrderType: OrderType;

	RevenueCenter: RevenueCenter;

	MissingBeverage: MBCheck;

	StationOpened: Station;

	StationClosed: Station;

	DeleteRecords: DeleteRecord[];

	GuestVenueVisit: GuestVenueVisit[];

	public constructor(init?: Partial<CheckRecord>) {
		Object.assign(this, init);
	}
}
